import { useSyncExternalStore } from 'react';

import {
  GX_TOKEN_STORAGE_ATTRIBUTE_NAME,
  PATHNAME_STORAGE_ATTRIBUTE_NAME,
  TRIP_TOKEN_STORAGE_ATTRIBUTE_NAME
} from '@/constants/constants';

const STORAGE_EVENT = 'token_storage_event';

const useStorage = (item: string, storage: Storage) =>
  useSyncExternalStore(
    onStoreChange => {
      window.addEventListener('storage', onStoreChange);
      window.addEventListener(STORAGE_EVENT, onStoreChange);
      return () => {
        window.removeEventListener('storage', onStoreChange);
        window.removeEventListener(STORAGE_EVENT, onStoreChange);
      };
    },
    () => storage.getItem(item)
  );

export const useTripTokenFromStorage = () =>
  useStorage(TRIP_TOKEN_STORAGE_ATTRIBUTE_NAME, sessionStorage);

export const getTripTokenFromStorage = () =>
  sessionStorage.getItem(TRIP_TOKEN_STORAGE_ATTRIBUTE_NAME);
export const setTripTokenToStorage = (tripToken: string): void => {
  sessionStorage.setItem(TRIP_TOKEN_STORAGE_ATTRIBUTE_NAME, tripToken);
  window.dispatchEvent(new Event(STORAGE_EVENT));
};

export const useGxTokenFromStorage = () =>
  useStorage(GX_TOKEN_STORAGE_ATTRIBUTE_NAME, localStorage);

export const getGxTokenFromStorage = () => localStorage.getItem(GX_TOKEN_STORAGE_ATTRIBUTE_NAME);
export const setGxTokenToStorage = (gxToken: string): void => {
  localStorage.setItem(GX_TOKEN_STORAGE_ATTRIBUTE_NAME, gxToken);
  window.dispatchEvent(new Event(STORAGE_EVENT));
};

export const setPathnameToStorage = (pathname: string): void => {
  localStorage.setItem(PATHNAME_STORAGE_ATTRIBUTE_NAME, pathname);
  window.dispatchEvent(new Event(STORAGE_EVENT));
};

export const usePathnameFromStorage = () =>
  useStorage(PATHNAME_STORAGE_ATTRIBUTE_NAME, localStorage);

export const clearPathnameFromStorage = () => {
  localStorage.removeItem(PATHNAME_STORAGE_ATTRIBUTE_NAME);
};

export const clearStoragesFromTokensAndUserInfo = () => {
  sessionStorage.removeItem(TRIP_TOKEN_STORAGE_ATTRIBUTE_NAME);
  localStorage.removeItem(GX_TOKEN_STORAGE_ATTRIBUTE_NAME);
  window.dispatchEvent(new Event(STORAGE_EVENT));
};
